import React from "react";
import styles from "./skill.module.css";

/**
 * A generic skill component
 * @module SkillComponent
 
 @prop {String} [skillName] : skill name
 @prop {String} [image] : skill image svg
**/

function Skill(props) {
    return (
        <div className={styles.skillContainer}>
            <div className={styles.skillImage}>
                <div className={styles.image}>{props.image}</div>
            </div>
            <div className={styles.skillName}>
                <p className={styles.title}>{props.skillName}</p>
            </div>
        </div>
    );
}

export default Skill;